import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as bugReportsActions from '../../redux/actions/bugReportsActions';

import BugReportItem from '../common/BugReportItem';

class BugReportPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'open',
      sort: 'desc', // newest first
      institution: 'all',
      tags: [],
      search: '',
    };
  }

  componentDidMount() {
    const { dispatchBugReportsActions } = this.props;
    dispatchBugReportsActions.getBugReports();
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  toggleTag = (id) => {
    const { tags } = this.state;
    if (tags.indexOf(id) !== -1) {
      // Remove that tag id
      this.setState(prevState => ({ tags: prevState.tags.filter(tag => tag !== id) }));
    } else {
      // Add that tag id
      this.setState(prevState => ({ tags: [...prevState.tags, id] }));
    }
  }

  addTag = (reportId, tagId) => {
    const { dispatchBugReportsActions, reports } = this.props;
    dispatchBugReportsActions.updateBugReport({
      id: reportId,
      tags: [...reports[reportId].tags, tagId],
    });
  }

  removeTag = (reportId, tagId) => {
    const { dispatchBugReportsActions, reports } = this.props;
    dispatchBugReportsActions.updateBugReport({
      id: reportId,
      tags: reports[reportId].tags.filter(tag => tag !== tagId),
    });
  }

  toggleReportStatus = (id) => {
    const { dispatchBugReportsActions, reports } = this.props;
    dispatchBugReportsActions.updateBugReport({
      id,
      isOpen: !reports[id].isOpen,
    });
  }

  render() {
    const { reports, allTags, institutions } = this.props;
    const { status, sort, institution, tags, search } = this.state;

    const filteredBugReports = Object.values(reports).filter(br => (
      // Filter by status
      (status === 'all'
        || (status === 'open' && br.isOpen)
        || (status === 'closed' && !br.isOpen)
      )
      // Filter by institution
      && (br.institution.toString() === institution || institution === 'all')
      // Filter by tags
      && tags.every(tag => br.tags.indexOf(parseInt(tag, 10)) !== -1)
      // Filter by search
      && search.split(' ').every(word => br.message.indexOf(word) !== -1)
    ));
    // Sort reports
    const sortedBugReports = filteredBugReports.sort((a, b) => (
      sort === 'desc'
        ? new Date(b.createdAt) - new Date(a.createdAt)
        : new Date(a.createdAt) - new Date(b.createdAt)
    ));

    return (
      <Fragment>
        <Helmet>
          <title>Bug Reports</title>
        </Helmet>
        <div className="page-header">
          <div className="row">
            <h1 className="page-header__heading">Bug Reports</h1>
          </div>
        </div>
        <div className="row">
          <div className="bug-report-head text">
            <p>
              Status:
              {' '}
              <select value={status} name="status" onChange={this.handleChange}>
                <option value="all">All</option>
                <option value="open">Open</option>
                <option value="closed">Closed</option>
              </select>
              {' \xa0'}
              Sort:
              {' '}
              <select value={sort} name="sort" onChange={this.handleChange}>
                <option value="desc">Newest first</option>
                <option value="asc">Oldest first</option>
              </select>
              {' \xa0'}
              Institution:
              {' '}
              <select value={institution} name="institution" onChange={this.handleChange}>
                <option value="all">All</option>
                {Object.entries(institutions).map(([id, name]) => (
                  <option value={id} key={id}>{name}</option>
                ))}
              </select>
              {' \xa0'}
              Search:
              {' '}
              <input value={search} name="search" onChange={this.handleChange} />
            </p>
            <p>
              Tags:
              {' '}
              {Object.entries(allTags).map(([id, name]) => (
                <label key={id}>
                  <input
                    type="checkbox"
                    value={tags.indexOf(id) !== -1}
                    onChange={() => this.toggleTag(id)}
                  />
                  {name + ' \xa0'}
                </label>
              ))}
            </p>
          </div>
          <div>
            {sortedBugReports.map(br => (
              <BugReportItem
                key={br.id}
                report={br}
                institutionName={institutions[br.institution]}
                tags={br.tags.map(id => ({ id, name: allTags[id] }))}
                removeTag={this.removeTag}
                allTags={allTags}
                addTag={this.addTag}
                toggleReportStatus={this.toggleReportStatus}
              />
            ))}
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    reports: state.bugReports.reports || {},
    allTags: state.bugReports.tags || {},
    institutions: state.bugReports.institutions || {},
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatchBugReportsActions: bindActionCreators(bugReportsActions, dispatch) };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BugReportPage);



// WEBPACK FOOTER //
// ./src/components/pages/BugReportPage.js